import { render, staticRenderFns } from "./detailDrCenterbanner.vue?vue&type=template&id=0727bd4e&scoped=true"
import script from "./detailDrCenterbanner.vue?vue&type=script&lang=js"
export * from "./detailDrCenterbanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727bd4e",
  null
  
)

export default component.exports